import React from "react";
import useAdminListSMS from "../hooks/useAdminListSMS";
import useAPI from "../hooks/useAPI";
import StickyHeadTable from "./StickyHeadTable";
import { isMobile } from "react-device-detect";
import { useDispatch, useSelector } from "react-redux";
import { campaignsActions } from "../state/campaigns";

export default function AdminListSMS(props) {
  const { sendSMS, onEdit, businessType } = useAdminListSMS(props);

  const dispatch = useDispatch();

  const { data: dataCampaigns, query: fetchData } = useAPI({
    type: "get",
    url: `campaigns`,
  });

  const items = useSelector((state) => state.campaigns.campaigns);

  const handleRefreshData = async () => {
    await fetchData();
  };

  React.useEffect(() => {
    if (dataCampaigns && dataCampaigns.data) {
      dispatch(campaignsActions.fetchAll(dataCampaigns.data));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dataCampaigns]);

  // useMemo est utilisé ici pour mémoriser la définition des
  // colonnes affichées dans le tableau.
  // permet d'éviter de recréer l'objet des colonnes à chaque rendu du composant,
  const displayedColumns = React.useMemo(() => {
    const baseColumns = [
      { id: "id", label: "ID", minWidth: 50 },
      { id: "name", label: "Name", minWidth: 100 },
      { id: "status", label: "Status", minWidth: 100 },
      { id: "created", label: "Date", minWidth: 100 },
      { id: "action", label: "Actions", minWidth: isMobile ? 90 : 90 },
    ];
    return baseColumns;
  }, []);

  return (
    <div>
      <StickyHeadTable
        businessType={businessType}
        filters={["id", "name", "status", "created"]}
        columns={
          isMobile
            ? displayedColumns.filter(
                (c) => c.id === "name" || c.id === "action"
              )
            : displayedColumns
        }
        data={items.map((c) => ({
          id: c.id.toString(),
          name: c.name,
          status: c.status.toString(),
          created: new Date(c.created).toLocaleDateString("fr-FR"),
          metadata: c.metadata,
        }))}
        onEdit={onEdit}
        onEdit2={() => {
          console.log("Edit 2 clicked");
        }}
        onRefreshData={handleRefreshData}
        onSendSMS={sendSMS}
      />
    </div>
  );
}
